import { render, staticRenderFns } from "./DatosCompanyListGroup.vue?vue&type=template&id=38b79a7c"
import script from "./DatosCompanyListGroup.vue?vue&type=script&lang=js"
export * from "./DatosCompanyListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports